var refresh = "https://shopfront-cdn.tekoapis.com/static/07001edfcdc8d627.svg";

export { refresh as default };
